(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var nativeFetch=window.fetch.bind(window);
  var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  function money(c){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(c/100);}catch(e){return (c/100).toFixed(2);}}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}

  /* ---------- Drawer markup ---------- */
  var d=document.createElement('dialog');
  d.className='tv-cd';d.setAttribute('aria-label','Your cart');
  d.innerHTML='<div class="tv-cd__bg" data-cd-close></div>'+
    '<aside class="tv-cd__panel">'+
      '<header class="tv-cd__head"><h2>Your cart <span class="tv-cd__count" data-cd-count></span></h2><button type="button" class="tv-cd__x" data-cd-close aria-label="Close cart"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></header>'+
      '<div class="tv-cd__note"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg><span>Tracked delivery in 10 to 12 business days</span></div>'+
      '<div class="tv-cd__body" data-cd-body></div>'+
      '<footer class="tv-cd__foot" data-cd-foot></footer>'+
    '</aside>';
  function mount(){if(!d.isConnected)document.body.appendChild(d);}
  if(document.body)mount();else document.addEventListener('DOMContentLoaded',mount);

  var lastFocus=null;
  function open(){
    mount();lastFocus=document.activeElement;
    if(!d.open){try{d.showModal();}catch(e){d.setAttribute('open','');}}
    document.documentElement.classList.add('tv-lock');
    requestAnimationFrame(function(){requestAnimationFrame(function(){d.classList.add('is-open');});});
  }
  function close(){
    d.classList.remove('is-open');document.documentElement.classList.remove('tv-lock');
    setTimeout(function(){if(d.open){try{d.close();}catch(e){d.removeAttribute('open');}}if(lastFocus&&lastFocus.focus)lastFocus.focus();},300);
  }
  d.addEventListener('cancel',function(e){e.preventDefault();close();});
  window.TVCart={open:function(){open();render().catch(function(){});},close:close,refresh:render};

  function setCounts(n){document.querySelectorAll('[data-tv-count]').forEach(function(el){el.textContent=n;el.hidden=n===0;});}

  function render(c){
    var p=c?Promise.resolve(c):nativeFetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()});
    return p.then(function(cart){
      cur=cart.currency||cur;setCounts(cart.item_count);
      d.querySelector('[data-cd-count]').textContent=cart.item_count?'('+cart.item_count+')':'';
      var body=d.querySelector('[data-cd-body]'),foot=d.querySelector('[data-cd-foot]');
      if(!cart.item_count){
        body.innerHTML='<div class="tv-cd__empty"><div class="tv-cd__emptyic"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 12.1a2 2 0 0 1-2 1.9H8.2a2 2 0 0 1-2-1.9Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg></div><h3>Your cart is empty</h3><p>Let\'s find something fun.</p><a class="tv-btn tv-btn--primary" href="'+root+'collections/all">Shop all toys</a></div>';
        foot.innerHTML='';return cart;
      }
      body.innerHTML=cart.items.map(function(it){
        var save=it.original_line_price>it.final_line_price;
        return '<div class="tv-cd__item" data-key="'+esc(it.key)+'">'+
          '<a href="'+esc(it.url)+'" class="tv-cd__img">'+(it.image?'<img src="'+esc(img(it.image,200))+'" alt="'+esc(it.product_title)+'" loading="lazy">':'')+'</a>'+
          '<div class="tv-cd__info"><a href="'+esc(it.url)+'" class="tv-cd__title">'+esc(it.product_title)+'</a>'+
          (it.variant_title&&!it.product_has_only_default_variant?'<div class="tv-cd__var">'+esc(it.variant_title)+'</div>':'')+
          '<div class="tv-cd__row"><div class="tv-cd__qty"><button type="button" data-q="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div>'+
          '<div class="tv-cd__price">'+(save?'<s>'+money(it.original_line_price)+'</s>':'')+'<b>'+money(it.final_line_price)+'</b></div></div>'+
          '<button type="button" class="tv-cd__rm" data-q="0">Remove</button></div></div>';
      }).join('');
      var saved=cart.original_total_price-cart.total_price;
      foot.innerHTML=(saved>0?'<div class="tv-cd__line tv-cd__save"><span>You save</span><b>'+money(saved)+'</b></div>':'')+
        '<div class="tv-cd__line tv-cd__sub"><span>Subtotal</span><b>'+money(cart.total_price)+'</b></div>'+
        '<p class="tv-cd__tax">Taxes and shipping calculated at checkout</p>'+
        '<a class="tv-btn tv-btn--primary tv-cd__checkout" href="'+root+'checkout"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Secure checkout</a>'+
        '<div class="tv-cd__links"><a href="'+root+'cart">View cart</a><span>&middot;</span><a href="#" data-cd-close>Continue shopping</a></div>'+
        '<div class="tv-cd__trust"><span>7-day returns</span><span>Secure payment</span><span>Tracked shipping</span></div>';
      return cart;
    });
  }

  d.addEventListener('click',function(e){
    if(e.target.closest('[data-cd-close]')){e.preventDefault();close();return;}
    var q=e.target.closest('[data-q]');if(!q)return;
    var item=q.closest('[data-key]');item.classList.add('is-busy');
    nativeFetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.dataset.key,quantity:parseInt(q.dataset.q,10)})})
      .then(function(r){return r.json()}).then(function(c){render(c)}).catch(function(){item.classList.remove('is-busy')});
  });

  /* Header cart icon opens drawer (except on the cart page) */
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-tv-cart-open]');
    if(!a||/\/cart\/?$/.test(location.pathname))return;
    e.preventDefault();window.TVCart.open();
  });

  /* Quick Add / Buy Now on product cards */
  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-tv-quick]');if(!form)return;
    e.preventDefault();
    var btn=e.submitter||form.querySelector('[data-tv-action="add"]');
    var action=btn&&btn.dataset.tvAction||'add';
    var id=form.querySelector('[name="id"]').value;
    btn.setAttribute('data-loading','');
    nativeFetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;})})
      .then(function(){
        if(action==='buy'){window.location.href=root+'checkout';return;}
        btn.removeAttribute('data-loading');window.TVCart.open();
      })
      .catch(function(err){btn.removeAttribute('data-loading');alert((err&&(err.description||err.message))||'Sorry, this item could not be added.');});
  });

  /* Any other add-to-cart on the site (product page button, theme quick add) also opens the drawer */
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&(input.url||input.href))||String(input||'');
    var p=nativeFetch(input,init);
    if(/\/cart\/add(\.js)?(\?|$)/.test(url)){
      p.then(function(r){if(r.ok)setTimeout(function(){window.TVCart.open();},150);}).catch(function(){});
    }
    return p;
  };
  window.addEventListener('pageshow',function(){render().catch(function(){})});
})();
